// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"CommonLoading_componentStyle__fWO2V","loading-anime":"CommonLoading_loading-anime__aXVmc"};